import React from "react";

interface InboundCallIconProps {
  className?: string;
}

const InboundCallIcon: React.FC<InboundCallIconProps> = ({
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      className={className}
    >
      <path
        d="M12.8152 11.6523C12.8152 11.8623 12.7685 12.0781 12.6693 12.2881C12.5702 12.4981 12.4419 12.6965 12.2727 12.8831C11.9869 13.1981 11.6718 13.4256 11.316 13.5715C10.966 13.7173 10.5869 13.7931 10.1785 13.7931C9.58352 13.7931 8.94768 13.6531 8.27685 13.3673C7.60602 13.0815 6.93518 12.6965 6.27018 12.2123C5.59935 11.7223 4.96352 11.1798 4.35685 10.579C3.75602 9.9723 3.21352 9.33647 2.72935 8.67147C2.25102 8.00647 1.86602 7.34147 1.58602 6.6823C1.30602 6.0173 1.16602 5.38147 1.16602 4.7748C1.16602 4.37813 1.23602 3.99897 1.37602 3.64897C1.51602 3.29313 1.73768 2.96646 2.04685 2.6748C2.42018 2.3073 2.82852 2.12646 3.26018 2.12646C3.42352 2.12646 3.58685 2.16146 3.73268 2.23146C3.88435 2.30146 4.01852 2.40646 4.12352 2.55813L5.47685 4.46563C5.58185 4.61147 5.65768 4.74563 5.71018 4.87397C5.76268 4.99647 5.79185 5.11897 5.79185 5.2298C5.79185 5.3698 5.75102 5.5098 5.66935 5.64396C5.59352 5.77813 5.48268 5.91813 5.34268 6.05813L4.89935 6.51896C4.83518 6.58313 4.80602 6.65897 4.80602 6.7523C4.80602 6.79897 4.81185 6.8398 4.82352 6.88647C4.84102 6.93313 4.85852 6.96813 4.87018 7.00313C4.97518 7.19563 5.15602 7.44647 5.41268 7.7498C5.67518 8.05313 5.95518 8.3623 6.25852 8.67147C6.57352 8.98063 6.87685 9.26647 7.18602 9.52897C7.48935 9.78563 7.74018 9.96063 7.93852 10.0656C7.96768 10.0773 8.00268 10.0948 8.04352 10.1123C8.09018 10.1298 8.13685 10.1356 8.18935 10.1356C8.28852 10.1356 8.36435 10.1006 8.42852 10.0365L8.87185 9.59897C9.01768 9.45313 9.15768 9.3423 9.29185 9.2723C9.42602 9.19063 9.56018 9.1498 9.70602 9.1498C9.81685 9.1498 9.93352 9.17313 10.0618 9.22563C10.1902 9.27813 10.3244 9.35397 10.4702 9.45313L12.401 10.824C12.5527 10.929 12.6577 11.0515 12.7218 11.1973C12.7802 11.3431 12.8152 11.489 12.8152 11.6523Z"
        stroke="currentColor"
        strokeWidth="0.875"
        strokeMiterlimit="10"
      />
      <path
        d="M9.44922 5.50996H12.2492M9.44922 5.50996V2.70996V5.50996Z"
        stroke="currentColor"
        strokeWidth="0.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default InboundCallIcon;
